module.exports = __webpack_public_path__ + "img/4bd8b4b.svg";